<div class="cart-item-list">
  <span class="header">
    {{ "cartitemslist.title" | cxTranslate }} ({{ items.length }})
  </span>

  <table role="table" class="cart-table" aria-describedby="carttable">
    <thead>
      <tr role="row" class="cx-item-list-header">
        <th role="columnheader" class="cx-item-list-desc"></th>
        <th role="columnheader" class="cx-item-list-qty">
          {{ "cartitemslist.quantity" | cxTranslate }}
        </th>
        <th role="columnheader" class="cx-item-list-qty"></th>
        <th role="columnheader" class="cx-item-list-actions">
          {{ "cartitemslist.itemPrice" | cxTranslate }}
        </th>
        <th role="columnheader" class="cx-item-list-total">
          {{ "cartitemslist.total" | cxTranslate }}
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of items; let i = index">
        <ng-container *ngIf="getControl(item) | async as control" [class.is-changed]="control.get('quantity').disabled">
          <tr cart-item-list-row role="row" class="cx-item-list-row" [afterSimulateAction]="afterSimulateAction"
            [item]="item" [itemLength]="items.length" [quantityControl]="control.get('quantity')" [readonly]="readonly"
            [promotionLocation]="promotionLocation" [options]="options" (qtyUpdateEvent)="qtyUpdateEvent($event)"></tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
</div>